import { http } from '../../config/axios'
 
export default function patchNotificacaoVisualizado(idNotificacao: string): Promise<string> {
  return http
    .patch('api/notificacao/marcarleitura/'+idNotificacao)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro patch notificacao visualizado', error)
      throw Error(error.response.data)
    })
}